export default {
  add_items: 'Ajouter des articles',
  remove_items: 'Supprimer des articles',
  place_order: 'Passer la commande',
  pay_now: 'Payer maintenant · {{amount}}',
  go_to_menu: 'Voir le menu',
  secure_checkout: 'Paiement sécurisé...',

  modals: {
    account_switch: {
      title: 'Un compte avec le numéro {{phoneNumber}} existe déjà',
      description: 'Nous vous avons connecté à votre compte existant en conservant les informations saisies 😊',
      button: 'Continuer',
    },
  },

  error_messages: {
    payment_unsuccessful: {
      title: 'Paiement échoué',
      description: 'Veuillez vérifier vos informations de paiement et réessayer.',
    },
    internal_error: {
      title: 'Commande échouée 😔',
      description:
        "Malheureusement, un problème inattendu est survenu avec votre commande, notre équipe technique s'en occupe déjà 🛠️.",
    },
    order_blocked: {
      title: 'Commande bloquée',
      description:
        "Nous avons détecté une activité suspecte sur votre compte et bloqué les nouvelles commandes jusqu'au {{datetime}}. Contactez le support à {{supportEmail}} pour plus de détails.",
      description_no_datetime:
        'Nous avons détecté une activité suspecte sur votre compte et bloqué les nouvelles commandes. Contactez le support à {{supportEmail}} pour plus de détails.',
    },
  },

  toasts: {
    input_errors_found: 'Il y a des problèmes avec vos informations de commande',
    select_payment_method: 'Choisis un moyen de paiement pour passer ta commande.',
  },
};
